import { createFileRoute, redirect } from '@tanstack/react-router';

import { session } from '@/lib/auth/session';
import { useNavState } from '@/lib/nav-state';
import { VerifyEmailScreen } from '@/screens/auth/VerifyEmailScreen';

/** The address travels in history state or comes from the session, never in the URL. */
export const Route = createFileRoute('/_auth/verify-email')({
  beforeLoad: ({ location }) => {
    if (!location.state.email && !session.get().user?.email) throw redirect({ to: '/sign-in' });
  },
  component: VerifyEmailRoute,
});

function VerifyEmailRoute() {
  const { email, codeSent } = useNavState();
  return <VerifyEmailScreen email={email ?? session.get().user?.email ?? ''} codeSent={codeSent} />;
}
